var _g, _rect, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 502,
    height: 502,
    viewBox: "0 0 502 502",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_40_311)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 60,
    width: 382,
    height: 382,
    rx: 76,
    fill: "#0A0929"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_40_311",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 60,
    width: 382,
    height: 382
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 60,
    width: 382,
    height: 382,
    fill: "#0A0929"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_40_311)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_40_311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.568 226.25C324.683 226.25 327.515 228.058 328.826 230.884L362.393 303.266C364.309 307.397 362.395 312.292 358.185 314.028L330.067 325.619C326.048 327.276 321.442 325.42 319.693 321.441L282.805 237.468C280.483 232.181 284.355 226.25 290.129 226.25L321.568 226.25Z",
    fill: "#3A5AFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_40_311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.788 301.903C187.308 300.06 189.572 298.993 191.96 298.993L358.475 298.993C365.075 298.993 368.836 306.533 364.866 311.805L342.233 341.863C340.722 343.871 338.355 345.051 335.842 345.051L167.169 345.051C160.405 345.051 156.694 337.179 160.997 331.961L185.788 301.903Z",
    fill: "#59B9FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_40_311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.244 313.005C139.623 310.344 139.695 306.984 141.429 304.395L238.949 158.722C241.445 154.993 246.52 154.046 250.193 156.624L275.914 174.678C279.487 177.186 280.39 182.097 277.941 185.712L172.125 341.95C168.859 346.773 161.697 346.599 158.668 341.624L141.244 313.005Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 253.596,
    y: 141.144,
    width: 26.0103,
    height: 73.3993,
    rx: 13.0051,
    transform: "rotate(-15 253.596 141.144)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26.0103,
    height: 73.4821,
    rx: 13.0051,
    transform: "matrix(-0.258819 -0.965926 -0.965926 0.258819 285.117 159.446)",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_40_311",
    x: 0,
    y: 0,
    width: 502,
    height: 502,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.0352941 0 0 0 0 0.160784 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_40_311"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_40_311",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_40_311",
    x: 120.077,
    y: 117.242,
    width: 266.413,
    height: 248.222,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945833 0 0 0 0 0.945833 0 0 0 0 0.945833 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_40_311"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_40_311",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_40_311",
    x: 119.154,
    y: 258.993,
    width: 287.336,
    height: 126.058,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_40_311"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_40_311",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_40_311",
    x: 100.077,
    y: 115.172,
    width: 219.242,
    height: 270.292,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_40_311"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_40_311",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.74aabf6d76a0f284b841289fc0400fa1.svg";
export { ForwardRef as ReactComponent };